import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import {
  cycleThemePreference,
  readThemePreference,
  setThemePreference,
} from './theme';

const OPTIONS = [
  { id: 'light', label: 'Light', Icon: Sun },
  { id: 'dark', label: 'Dark', Icon: Moon },
];

export default function ThemeToggle({ collapsed = false, compact = false }) {
  const [preference, setPreference] = useState(readThemePreference);

  if (collapsed) {
    const ActiveIcon = preference === 'light' ? Sun : Moon;
    return (
      <button
        type="button"
        onClick={() => setPreference(cycleThemePreference(preference))}
        className={`flex justify-center rounded-lg p-2 text-orca-muted transition-colors hover:bg-orca-raised hover:text-orca-strong ${
          compact ? 'shrink-0' : 'w-full'
        }`}
        title={`Theme: ${preference}`}
        aria-label="Cycle theme (light, dark)"
      >
        <ActiveIcon className="h-4 w-4" />
      </button>
    );
  }

  return (
    <div className="rounded-lg border border-orca bg-orca-raised p-1">
      <div className="mb-1 px-2 pt-1 text-[10px] font-semibold uppercase tracking-wide text-orca-muted">
        Theme
      </div>
      <div className="grid grid-cols-2 gap-0.5">
        {OPTIONS.map(({ id, label, Icon }) => {
          const active = preference === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => {
                setThemePreference(id);
                setPreference(id);
              }}
              className={`flex flex-col items-center gap-0.5 rounded-md px-1 py-1.5 text-[10px] font-medium transition-colors ${
                active
                  ? 'bg-orca-accent orca-on-accent shadow-sm'
                  : 'text-orca-muted hover:bg-orca-panel hover:text-orca-strong'
              }`}
              title={label}
              aria-pressed={active}
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
